module.exports = __webpack_public_path__ + "25d0372f991cf294dafe3c555933581e.svg";